window.addEventListener('load', () => {
  const modal = document.getElementById('sizeGuideModal');
  const openBtn = document.getElementById('size-guide-trigger');
  const closeBtn = document.getElementById('closeSizeGuide');

  if (openBtn && modal) {
    openBtn.addEventListener('click', () => {
      modal.showModal();
    });
  }

  if (closeBtn && modal) {
    closeBtn.addEventListener('click', () => {
      modal.close();
    });
  }

  if (modal) {
    modal.addEventListener('click', (e) => {
      const rect = modal.getBoundingClientRect();
      if (
        e.clientX < rect.left ||
        e.clientX > rect.right ||
        e.clientY < rect.top ||
        e.clientY > rect.bottom
      ) {
        modal.close();
      }
    });
  }
});
